import {ObjectId} from 'bson';
import {
  AiBooleanFieldDefinitionSchema,
  AiRatingFieldDefinitionSchema,
  AiCategoryFieldDefinitionSchema,
  LegacyAiResearchFieldDefinitionSchema,
  CrmFieldDefinitionSchema,
  FieldDefinitionSchema,
  AiFieldDefinitionSchema,
  AiTeamSizeFieldDefinitionSchema,
  AiResearchFieldDefinitionSchema,
} from '../../enrichment';
import {ApiDefinition} from '../definitions';
import {z} from 'zod';

const creationFields = {
  id: true,
  timestamp: true,
} as const;
export const PostFieldDefinition = {
  path: 'fieldDefinition/createFieldDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.union([
    AiBooleanFieldDefinitionSchema.omit(creationFields),
    AiRatingFieldDefinitionSchema.omit(creationFields),
    AiCategoryFieldDefinitionSchema.omit(creationFields),
    AiTeamSizeFieldDefinitionSchema.omit(creationFields),
    AiResearchFieldDefinitionSchema.omit(creationFields),
    LegacyAiResearchFieldDefinitionSchema.omit(creationFields),
    CrmFieldDefinitionSchema.omit(creationFields),
  ]),
  responseDataSchema: FieldDefinitionSchema,
} satisfies ApiDefinition;

export const DeleteFieldDefinition = {
  path: 'fieldDefinition/deleteFieldDefinition',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    fieldId: z.instanceof(ObjectId),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const SaveFieldDefinition = {
  path: 'fieldDefinition/saveFieldDefinition',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    fieldDefinition: AiFieldDefinitionSchema,
  }),
  responseDataSchema: AiFieldDefinitionSchema,
} satisfies ApiDefinition;
